import {JetView} from "webix-jet"; // Importing JetView from webix-jet for creating views
import {devConfig} from "../../../config/config"; // Importing development configuration

/**
 * Class representing the TableJackpotPrizeReportCasinoView.
 * @extends JetView
 */
export default class TableJackpotPrizeReportCasinoView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService("locale")._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function

        /**
         * Formats a value as a percentage.
         * @param {number} value - The value to format.
         * @returns {string} The formatted percentage string.
         */
        function percentFormat(value) {
            return webix.i18n.numberFormat(value) + "%"; // Formatting value as percentage
        }

        return {
            rows: [
                {
                    cols: [
                        {
                            id: "datatable", // ID for the datatable
                            view: "datatable", // Defining the view as a datatable
                            scroll: "xy", // Enabling both horizontal and vertical scrolling
                            css: "webix_header_border webix_data_border webix_footer_border", // CSS classes for styling
                            columns: [
                                {
                                    id: "date", // Column ID for date
                                    header: _("Fecha"), // Column header with localization
                                    width: 200 // Column width
                                },
                                {
                                    id: "uniqueJackpotId", // Column ID for unique jackpot ID
                                    header: _("Id del Jackpot"), // Column header with localization
                                    width: 350 // Column width
                                },
                                {
                                    id: "Id", // Column ID for player identification
                                    header: _("Identificación del jugador ganador"), // Column header with localization
                                    width: 350 // Column width
                                },
                                {
                                    id: "documentType", // Column ID for document type
                                    header: _("Tipo de documento"), // Column header with localization
                                    width: 200 // Column width
                                },
                                {
                                    id: "documentNumber", // Column ID for document number
                                    header: _("Número de documento"), // Column header with localization
                                    width: 200 // Column width
                                },
                                {
                                    id: "gameName", // Column ID for game name
                                    header: _("Nombre del juego"), // Column header with localization
                                    width: 200 // Column width
                                },
                                {
                                    id: "totalAmountWon", // Column ID for total amount won
                                    header: _("Monto total ganado"), // Column header with localization
                                    width: 250 // Column width
                                },
                                {
                                    id: "progressiveSystemModality", // Column ID for progressive system modality
                                    header: _("Modalidad del sistema progresivo"), // Column header with localization
                                    width: 200 // Column width
                                },
                                {
                                    id: "paymentDate", // Column ID for payment date
                                    header: _("Fecha y hora del pago"), // Column header with localization
                                    width: 250 // Column width
                                },
                                {
                                    id: "initialProgressiveAmount", // Column ID for initial progressive amount
                                    header: _("Monto inicial del sistema progresivo"), // Column header with localization
                                    width: 250 // Column width
                                },
                                {
                                    id: "progressiveStartDate", // Column ID for progressive start date
                                    header: _("Fecha de inicio del sistema progresivo"), // Column header with localization
                                    width: 200 // Column width
                                },
                            ],
                            on: {
                                /**
                                 * Event handler for before loading data into the datatable.
                                 */
                                onBeforeLoad: function () {
                                    this.showOverlay("<div id='contenedor'; class='container-preload'><div style='position: fixed; top: calc(50% - 57px);left: calc(50% - 60px);width: 120px;' class='progress'><div class='icon-preload girando'></div><div class='load-text'>Loading... </div></div></div>");
                                },
                                /**
                                 * Event handler for after loading data into the datatable.
                                 */
                                onAfterLoad: function () {
                                    this.hideOverlay(); // Hiding the overlay after data load
                                }
                            },
                            /**
                             * Event handler for when the datatable is ready.
                             */
                            ready: function () {
                                if (!this.count()) { // Check if there are no records
                                    webix.extend(this, webix.OverlayBox); // Extend with overlay functionality
                                    this.showOverlay("<div class='no-data' style='margin:75px; font-size:18px;'>" + _('No hay datos') + "</div>"); // Show no data overlay
                                }
                            },
                            autowidth: false, // Disable automatic width adjustment
                            math: true, // Enable mathematical operations
                            datafetch: 10, // Number of records to fetch at a time
                            pager: "pagerA" // ID of the pager component
                        }
                    ]
                }
            ]
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     * @param {Object} grid - The datatable instance.
     */
    init(grid) {
        grid = $$('datatable'); // Getting the datatable instance
        let url = devConfig.geturlApi() + "/Financial/jackpotPrizeReport"; // API endpoint for fetching data

        // Event listener for filtering data based on user input
        this.on(this.app, "gamesPerformance:filter", filterData => {
            let object = Object.entries(filterData); // Convert filter data to entries
            let string1 = ""; // Initialize query string

            // Loop through filter data entries
            for (let i = 0; i < object.length; i++) {
                if ((typeof object[i][1] !== "object") && (object[i][1] !== "")) {
                    if (object[i][0] == "Datepicker") { // Handle date range filter
                        let date = object[i][1].split(" - ");
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] != "Sort" && object[i][0] != "Dir" && object[i][0] != "Date") {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Append other filters
                        } else {
                            if (object[i][0] == "Date") { // Handle single date filter
                                let date = object[i][1].replace(" 00:00:00", "");
                                string1 = string1 + '&dateFrom=' + date;
                                string1 = string1 + '&dateTo=' + date;
                            }
                        }
                    }
                } else {
                    if ((typeof object[i][1] === "object")) { // Handle object type filters
                        let object2 = Object.entries(object[i][1]); // Convert nested object to entries
                        for (let j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === "start") { // Handle start date
                                    let d = new Date(object2[j][1]);
                                    let dateFrom = "dateFrom=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom; // Append start date to query string
                                } else {
                                    if (object2[j][0] === "end") { // Handle end date
                                        let d = new Date(object2[j][1]);
                                        let dateTo = "dateTo=" + ((d.getFullYear())) + ":" + ("00" + (d.getMonth() + 1)).slice(-2) + ":" + ("00" + d.getDate()).slice(-2) + " " + ("00" + d.getHours()).slice(-2) + ":" + ("00" + d.getMinutes()).slice(-2) + ":" + ("00" + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo; // Append end date to query string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear existing data in the grid
            $$("consultDesk").define("disabled", true); // Disable consult desk during loading
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1).then((response) => {
                $$("consultDesk").define("disabled", false); // Re-enable consult desk after loading
            }).catch((e) => {
                $$("consultDesk").define("disabled", false); // Re-enable consult desk on error
            });
            $$("filterPopup").hide(); // Hide filter popup after applying filter
        });

        // Event listener for handling page changes in the pager
        $$("pagerA").attachEvent("onAfterPageChange", function (page) {
            webix.delay(function () {
                if (page != '0') {
                    chargeTable(); // Load data for the new page
                }
            }, '', '', 100);
        });

        // Event listener for changing size of the view
        this.on(this.app, "changeSize", filterData => {
            chargeTable(); // Reload table data on size change
        });

        /**
         * Loads data into the grid based on pagination.
         */
        function chargeTable() {
            let size = grid.getPager().config.size; // Get the number of records per page
            let page = grid.getPage(); // Get the current page number
            let first = size * page; // Calculate the starting record index
            let last = (first + size) - 1; // Calculate the last record index
            grid.load(url + '?start=' + (first) + '&count=' + (last + 1) + filter); // Load data for the current page
        }
    }
}

// FILE DOCUMENTED
